<script setup>
import { stateManager } from "@/stateManager.js";
import AppFooter from "./components/AppFooter.vue"
import AppSideNav from "./components/AppSideNav.vue";
import AppLogo from "./components/AppLogo.vue";
import AppSearchBar from "./components/AppSearchBar.vue";
import User from "./components/User.vue";
import { onMounted, ref, watch } from "vue";
import { countFavorites } from "./libs/favorites";
import { changeStyleSheet } from "./libs/utils";

const colorMode = ref('chiaro');
const users = ref([]);

async function getUsers () {
  const r = await fetch("/.netlify/functions/getUsers");
  const _users = await r.json();
  console.log(_users);
}

async function createUser () {
  const auth0_id = 'cmdfdjsjer'
  const name = 'Thich'
  const email = 'thich@gmail.com'

  const r = await fetch("/.netlify/functions/createUser", {
    method: "POST",
    headers: { "Content-Type": "application/json"},
    body: JSON.stringify({ auth0_id, name, email })
  });
  const user = await r.json();
  console.log(user);
}


onMounted(() => {
  removeSplashScreen();
    stateManager.animate(); // start webapp animation (fade-in)

    if (localStorage.colorMode) { // check user preferred color mode
      colorMode.value = localStorage.colorMode;
      changeStyleSheet(document, colorMode.value);
    }

    // check and set user FAVORITES number (displayed on the menu)
    stateManager.total_favorite_count = countFavorites();
});

watch(colorMode, (newVal) => {
      localStorage.colorMode = newVal;
      changeStyleSheet(document, colorMode.value);
})

// remove the splash screen with a fade out effect
function removeSplashScreen() {
  const el = document.getElementById('splash');
  if(el) {
    el.style.opacity = '0';
    setTimeout(() => el.remove(), 1000)
  }
}
</script>

<template>
  <div id="app" v-cloak>
    <!-- <button @click="getUsers">getUsers</button>
    <button @click="createUser">createUser</button> -->
    <nav class="navbar">
      <AppSideNav />
      <div class="navbar-content" :class="[{ animationShow_v1: stateManager.animationEnabled }]">
        <AppLogo />
        <AppSearchBar />
        <!-- <User /> -->
      </div>
    </nav>

    <router-view></router-view>
    <AppFooter />
  </div>
</template>

<style lang="scss">
  @import "@/assets/scss/light.css";
  @import "@/assets/scss/main.scss";
</style>
